import { GROUP_CHAT_FETCH_SIZE } from '~/features/chatRoom/useGetGroupChatListQuery';
import {
  CheckGroupChatMemberResponse,
  EnterGroupChatRequest,
  GetPreviousGroupChatResponse,
  GetGroupChatListResponse,
  GetGroupChatListRequest,
  CreateGroupChatRoomRequest,
  CreateGroupChatRoomResponse,
  EmptyResponse,
  GetGroupChatRoomInfoResponse,
  PaginationRequest,
  CheckGroupChatMemberRequest,
  LeaveChatRoomRequest,
  GetGroupChatRoomInfoRequest,
  GetPreviousGroupChatRequest,
  BlockUserRequest,
} from '~/types';
import { fetcher } from './config/fetcher';
import http from './config/http';

// export const getMyFavoriteCharacterList = async (
//   request: GetMyFavoriteCharacterListRequest,
// ) => {
//   return fetcher(() =>http.post<GetMyFavoriteCharacterListResponse>(
//     '/api/getMyFavoriteCharacterList',
//     request,
//   );
//     return { data: res.data, status: res.status };
// };

export const fetchGroupPreviousChat = async ({
  groupchat_id,
  last_evaluated_key,
}: GetPreviousGroupChatRequest) => {
  return fetcher(() =>
    http.get<GetPreviousGroupChatResponse>(
      `/groupchats/${groupchat_id}/chats`,
      {
        params: {
          last_evaluated_key,
        },
      },
    ),
  );
};

export const getGroupChatList = async ({
  page,
  page_size = GROUP_CHAT_FETCH_SIZE,
  type,
  query = '',
}: PaginationRequest<GetGroupChatListRequest>) => {
  return fetcher(() =>
    http.get<GetGroupChatListResponse>(`/groupchats`, {
      params: {
        type: type === 'all' ? null : type,
        search: query || null,
        page,
        page_size,
      },
    }),
  );
};

export const checkGroupChatMember = async ({
  chatroom_id,
}: CheckGroupChatMemberRequest) => {
  return fetcher<CheckGroupChatMemberResponse>(() =>
    http.get<CheckGroupChatMemberResponse>(
      `/groupchats/${chatroom_id}/connections`,
    ),
  );
};

export const enterGroupChat = async ({
  chatroom_id,
  ...request
}: EnterGroupChatRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/groupchats/${chatroom_id}/connections`, request),
  );
};

export const createGroupChatRoom = async (
  request: CreateGroupChatRoomRequest,
) => {
  return fetcher(() =>
    http.post<CreateGroupChatRoomResponse>('/groupchats', request),
  );
};

export const leaveGroupChatRoom = async ({
  chatroom_id,
}: LeaveChatRoomRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(`/groupchats/${chatroom_id}/connections`),
  );
};

export const getGroupChatroomInfo = async ({
  chatroom_id,
}: GetGroupChatRoomInfoRequest) => {
  return fetcher(() =>
    http.get<GetGroupChatRoomInfoResponse>(`/groupchats/${chatroom_id}`),
  );
};

export const updateUserBlock = async ({
  groupchat_id,
  block_user_id,
  isBlocking,
}: BlockUserRequest) => {
  return fetcher(() =>
    http.put<EmptyResponse>(
      `/groupchats/${groupchat_id}/users/${block_user_id}/block`,
      { block: isBlocking },
    ),
  );
};
